import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/basetao-spreadsheet-guide/page";
import ArticleReview from "../pages/article/basetao-review/page";
import ArticleLegit from "../pages/article/is-basetao-legit/page";
import ArticleShipping from "../pages/article/basetao-shipping-cost/page";
import ArticleCoupon from "../pages/article/basetao-coupon-guide/page";
import ArticleWarehouse from "../pages/article/basetao-warehouse-guide/page";
import ArticleVs from "../pages/article/basetao-vs-superbuy/page";
import ArticleBeginner from "../pages/article/basetao-beginner-guide/page";
import ArticleTutorial from "../pages/article/basetao-spreadsheet-tutorial/page";
import ArticleAlternatives from "../pages/article/basetao-alternatives/page";
import ArticleBuying from "../pages/article/basetao-buying-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/basetao-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/article/basetao-review",
    element: <ArticleReview />,
  },
  {
    path: "/article/is-basetao-legit",
    element: <ArticleLegit />,
  },
  {
    path: "/article/basetao-shipping-cost",
    element: <ArticleShipping />,
  },
  {
    path: "/article/basetao-coupon-guide",
    element: <ArticleCoupon />,
  },
  {
    path: "/article/basetao-warehouse-guide",
    element: <ArticleWarehouse />,
  },
  {
    path: "/article/basetao-vs-superbuy",
    element: <ArticleVs />,
  },
  {
    path: "/article/basetao-beginner-guide",
    element: <ArticleBeginner />,
  },
  {
    path: "/article/basetao-spreadsheet-tutorial",
    element: <ArticleTutorial />,
  },
  {
    path: "/article/basetao-alternatives",
    element: <ArticleAlternatives />,
  },
  {
    path: "/article/basetao-buying-guide",
    element: <ArticleBuying />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;